import React, { Component } from 'react';
import { Form } from 'react-bootstrap';
import { CFormGroupPassword } from './control.password';

const CFormGroup = {
    
}

export default CFormGroup